const defaultReports = [
    "PDV Changes",
    "Additions and Deductions analysis",
    "Payslip Summary",
    "Pension Summary",
    "Auto Enrolment Activity history",
    "Payroll Summary",
    "HMRC P32 Report",
    "Pay Spreadsheet",
    "BACS File Listing",
    "BACS Authorisation"
];

export default defaultReports;